__turbopack_context__.v({
  "className": "noto_nastaliq_urdu_96af2df5-module__KR3Dka__className",
});
